import React from "react";
import AllData from "../../components/product/table/component";

const Component = () => {
  return <AllData tableHeading="All Products" />;
};

export default Component;
